import {createApp} from 'vue'
import Webpage from './Webpage.vue'
import {router} from "@/router";
import VueClickAway from 'vue3-click-away'

createApp(Webpage)
    .use(router)
    .use(VueClickAway)
    .mount('#app')
